<div class="table-container">
  <table mat-table matSort [dataSource]="deviceNameDescriptionMatTableDataSource">

    <ng-container matColumnDef="deviceId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceId">{{'bacnet-device-table.header.device-id' | translate}}</th>
      <td mat-cell *matCellDef="let device">{{device.deviceId}}</td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceId">{{'bacnet-device-table.header.device-name' | translate}}</th>
      <td mat-cell *matCellDef="let device">{{device.objectName}}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description">{{'bacnet-device-table.header.description' | translate}}</th>
      <td mat-cell *matCellDef="let device">{{device.description}}</td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
